/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import createState from 'redux-create-state';

import * as appActions from './App-Actions';

import utils from '../../../../utils';

const INITIAL_STATE_APP = {
    config: {},
    featureFlags: {},
    relationshipList: {
        byId: {},
        byValue: {},
    },
    recipientType: '',
    abTest: {
        shortenedShipping: {},
        onePageCheckout: {},
        middlePlaceOrder: {},
        rememberMe: {},
        calendarMessage: {},
        modalQasRadioButtons: {},
        unverifiedAddresses: {},
        deliveryDateSelections: {},
        longerPassportMessage: {},
        enterpriseCalendar: {},
        newProductCardEnabled: {},
        cardisleGridView: {},
        deliveryTimeWindow: {},
        orderSummaryRemapping: {},
    },
    isAuth0TriggerCalled: false, // this is for One Page Checkout
};

const reducer = utils.createReducer(INITIAL_STATE_APP)({
    [appActions.setBrandConfig().type]: (state, action) => createState(state || {}, ['config', action.payload]),
    [appActions.setFeatureFlag().type]: (state, action) => createState(state || {}, ['featureFlags', action.payload]),
    [appActions.setRelationshipList().type]: (state, action) => createState(state || {}, ['relationshipList', action.payload]),
    [appActions.setRecipientType().type]: (state, action) => createState(state || {}, ['recipientType', action.payload]),
    [appActions.clearRecipientType().type]: (state) => createState(state || {}, ['recipientType', '']),
    [appActions.setRecaptchaCheckoutV2Token().type]: (state, action) => createState(state || {}, ['recaptchaV2Token', action.payload]),
    [appActions.clearRecaptchaCheckoutV2Token().type]: (state) => createState(state || {}, ['recaptchaV2Token', '']),
    [appActions.setShortenedShippingSaleForceABTest().type]: (state, action) => createState(state || {}, ['abTest.shortenedShipping', action.payload]),
    [appActions.setOnePageCheckoutSaleForceABTest().type]: (state, action) => createState(state || {}, ['abTest.onePageCheckout', action.payload]),
    [appActions.setIsAuth0TriggerCalled().type]: (state, action) => createState(state || {}, ['abTest.isAuth0TriggerCalled', action.payload]),
    [appActions.setMiddlePlaceOrderSaleForceABTest().type]: (state, action) => createState(state || {}, ['abTest.middlePlaceOrder', action.payload]),
    [appActions.setRememberMeSaleForceABTest().type]: (state, action) => createState(state || {}, ['abTest.rememberMe', action.payload]),
    [appActions.setCalendarMessageSaleForceABTest().type]: (state, action) => createState(state || {}, ['abTest.calendarMessage', action.payload]),
    [appActions.setModalQasRadioButtonsSaleForceABTest().type]: (state, action) => createState(state || {}, ['abTest.modalQasRadioButtons', action.payload]),
    [appActions.setCheckUnverifiedAddressesSaleForceABTest().type]: (state, action) => createState(state || {}, ['abTest.unverifiedAddresses', action.payload]),
    [appActions.setDeliveryDateSelectionsSalesForceABTest().type]: (state, action) => createState(state || {}, ['abTest.deliveryDateSelections', action.payload]),
    [appActions.setLongerPassportMessageSalesForceABTest().type]: (state, action) => createState(state || {}, ['abTest.longerPassportMessage', action.payload]),
    [appActions.setEnterpriseCalendarSalesForceABTest().type]: (state, action) => createState(state || {}, ['abTest.enterpriseCalendar', action.payload]),
    [appActions.setDeliveryTimeWindowSalesForceABTest().type]: (state, action) => createState(state || {}, ['abTest.deliveryTimeWindow', action.payload]),
    [appActions.setNewProductCardLayoutEnabled().type]: (state, action) => createState(state || {}, ['abTest.newProductCardEnabled', action.payload]),
    [appActions.setCardisleGridViewSaleForceABTest().type]: (state, action) => createState(state || {}, ['abTest.cardisleGridView', action.payload]),
    [appActions.setOrderSummaryRemappingSalesforceABTest().type]: (state, action) => createState(state || {}, ['abTest.orderSummaryRemapping', action.payload]),
});

export default reducer;
